module.exports = __webpack_public_path__ + "img/get_success.289e51e2.gif";